import { Component, ApplicationRef } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'document-scanner-preview-dialog',
  templateUrl: 'document-scanner-preview-dialog.html',
})
export class DocumentScannerPreviewDialog {
  public data: any;
  public deleteFunc: Function;

  constructor(
    private sanitizer: DomSanitizer,
    private applicationRef: ApplicationRef) {

  }

  public previewCapture(): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.data);
  }

  close() {
    this.applicationRef.tick();
  }

  delete() {
    this.deleteFunc();
    this.applicationRef.tick();
  }
}
